import type { OrgRole } from "@/types";

const roleConfig: Record<
  OrgRole,
  { label: string; bg: string; border: string; text: string; icon: string }
> = {
  owner: {
    label: "Owner",
    bg: "bg-[rgba(255,59,48,0.08)]",
    border: "border-[rgba(255,59,48,0.2)]",
    text: "text-[#cc0000]",
    icon: "★",
  },
  admin: {
    label: "Admin",
    bg: "bg-[rgba(56,182,255,0.08)]",
    border: "border-[rgba(56,182,255,0.2)]",
    text: "text-[#007aff]",
    icon: "🛡",
  },
  member: {
    label: "Member",
    bg: "bg-[rgba(0,0,0,0.04)]",
    border: "border-[rgba(0,0,0,0.04)]",
    text: "text-text-muted",
    icon: "👤",
  },
};

export default function RoleBadge({ role }: { role: OrgRole }) {
  const cfg = roleConfig[role];
  return (
    <span
      className={`self-start rounded-full px-2.5 py-1 border ${cfg.bg} ${cfg.border} flex items-center gap-1`}
    >
      <span className="text-xs" role="img" aria-label={cfg.label}>
        {cfg.icon}
      </span>
      <span className={`text-[0.625rem] font-bold uppercase tracking-[0.05em] ${cfg.text}`}>
        {cfg.label}
      </span>
    </span>
  );
}
